import React, {useState, useEffect} from 'react';
import {
  AUTH_START,
  AUTH_SUCCESS,
  AUTH_FAIL,
  TX_SEND,
  TX_CONFIRMATION,
  LOADING_START,
  LOADING_END,
  TX_SUCCESS,
  TX_FAIL,
  PRELOADING_START,
} from './types';

const INITIAL_STATE = {
  loading: false,
  preloading: true,
  error: null,
  user: null,
  tx: null,
  comment: null,
  cardType: null,
  stage: null,
  txStatus: null,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AUTH_START:
      return Object.assign({}, state, {loading: true, data: null, error: null});
    case AUTH_FAIL:
      return Object.assign({}, state, {loading: false, error: action.payload});
    case AUTH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        preloading: false,
        user: action.payload,
        error: null,
      });

    case TX_SEND:
      return Object.assign({}, state, {
        loading: true,
        tx: action.payload.result,
        cardType: action.payload.cardType,
      });
    case TX_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        txStatus: 'done',
        error: null,
      });
    case TX_FAIL:
      return Object.assign({}, state, {
        loading: false,
        txStatus: 'fail',
        error: action.payload,
      });

    case TX_CONFIRMATION:
      return Object.assign({}, state, {
        loading: false,
        txStatus: 'process',
        stage: action.payload.stage,
        comment: action.payload.comment,
        error: null,
      });
    case PRELOADING_START:
      return Object.assign({}, state, {preloading: true});
    case LOADING_START:
      return Object.assign({}, state, {loading: true});
    case LOADING_END:
      return Object.assign({}, state, {loading: false});

    default:
      return state;
  }
};

export default authReducer;
